import {Observable} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {Injectable, inject} from '@angular/core';
import {Endpoint} from '../../layout/endpoint';
import {HomePageConfiguration} from './homepageconfiguration';
import {FilterResult} from '../../resource/filterresult';
import {BaseApiService} from '../../core/services/base-api.service';
import {SupportedLocaleConfigurationService} from './supportedlocaleconfiguration.service';

@Injectable()
export class HomePageConfigurationService extends BaseApiService {
  private localeService = inject(SupportedLocaleConfigurationService);

  public getHomePageConfigurations(): Observable<HomePageConfiguration[]> {
    const attributes = [
      this.getAttr('DisplayName'),
      this.getAttr('UsageKeyword'),
      this.getAttr('Description'),
      this.getAttr('UrlID'),
      this.getAttr('ParentOrder'),
      this.getAttr('Order'),
      this.getAttr('Icon'),
      this.getAttr('SiteType'),
      this.getAttr('LinkedObject'),
      this.getAttr('ActionBarResources'),
    ].filter(attr => attr !== null);

    return this.layoutService.endpoint$.pipe(
      take(1),
      switchMap((env: Endpoint) => {
        const filter =
          '/' + this.getType('HomepageConfiguration') + (!env.isCloud() ? '[Region=1]' : '');

        return this.getWithLocale<FilterResult>(
          filter,
          attributes,
          10000,
          this.localeService.getSupportedLocaleConfiguration(),
        ).pipe(map(response => this.toHomePageConfigurationsW(response.Results)));
      }),
    );
  }

  private toHomePageConfigurationsW(navbars: any): HomePageConfiguration[] {
    let finalNavbars: HomePageConfiguration[] = [];
    navbars.forEach(obj => {
      finalNavbars.push(this.toHomePageConfiguration(obj));
    });
    return finalNavbars;
  }

  private toHomePageConfiguration(r: any): HomePageConfiguration {
    return <HomePageConfiguration>{
      id: r[this.getAttr('ObjectID')],
      displayname: r[this.getAttr('DisplayName')],
      description: r[this.getAttr('Description')],
      usagekeyword: r[this.getAttr('UsageKeyword')],
      urlid: r[this.getAttr('UrlID')],
      parentorder: r[this.getAttr('ParentOrder')],
      order: r[this.getAttr('Order')],
      icon: r[this.getAttr('Icon')],
      sitetype: r[this.getAttr('SiteType')],
      linkedobject: r[this.getAttr('LinkedObject')],
      actionbarresources: r[this.getAttr('ActionBarResources')],
    };
  }
}
